
import React from 'react';
import { Container, Stack, Typography } from '@mui/material';
import MainLayout from '../../components/mainLayout/MainLayout';
import Loader from '../../components/Loader';

const LoaderPage = () => {
    return <MainLayout>
        <Container maxWidth='lg'>
            <Stack
                justifyContent="center"
                alignItems="center"
                textAlign={'center'}
                spacing={16}
                height={'65vh'}
            >
                <Stack alignItems={'center'} direction={'row'} gap={2}>
                    <Loader size={'3rem'} />
                </Stack>
                <Typography mt={8}>Application Loading Please wait...</Typography>
            </Stack>
        </Container>
    </MainLayout >
}

export default LoaderPage